import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';
import { Spinner } from '@hotjar/webapp/components/Spinner';
import { Blur } from '@hotjar/webapp/components/Blur';

const HeroSection = styled.section`
  padding: 24px 10%;
  background-color: ${tokens.color.neutral_100};
`;

const HeroContent = styled.dl<{ maxWidth?: number }>`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      margin: 0 auto;
      max-width: ${maxWidth}px;
    `}
`;

const HeroTitle = styled.dt`
  ${tokens.text('caption')}
  display: block;
  color: ${tokens.color.text_default};
  margin: 0 0 ${tokens.spacer.x1};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const HeroValue = styled.dd`
  ${tokens.text('header4')}
  color: ${tokens.color.text_default};
  margin: 0;
`;

export interface HeroStat {
  title: string;
  value: string;
}

interface HeroStatsProps {
  items: HeroStat[];
  loading?: boolean;
  blurred?: boolean;
  contentMaxWidth?: number;
}

export function HeroStats(props: HeroStatsProps): JSX.Element {
  const { items, loading, blurred, contentMaxWidth } = props;

  function renderValue(value: string) {
    if (loading) return <Spinner size={tokens.spacer.x3} color={tokens.color.azure} />;
    if (blurred) return <Blur>{value}</Blur>;
    return value;
  }

  return (
    <HeroSection>
      <HeroContent maxWidth={contentMaxWidth}>
        {items.map(({ title, value }) => (
          <div key={title}>
            <HeroTitle>{title}</HeroTitle>
            <HeroValue>{renderValue(value)}</HeroValue>
          </div>
        ))}
      </HeroContent>
    </HeroSection>
  );
}
